import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import { log } from "../utils/logger";
import { isLocal } from "../utils/env";

const MOCK_CALLS = [
  // 'auth', // Mock authentication
];

if (isLocal()) {
  log("%cSetting up mock calls", "color: green; font-weight: bold;");

  // This sets the mock adapter on the default instance
  const mock = new MockAdapter(axios);

  // ==============================================================================================
  // Auth =========================================================================================
  // ==============================================================================================

  if (MOCK_CALLS.includes("auth")) {
    mock.onPost("auth/log-in").reply(200, {
      status: "success",
      user: require("./generateUser"),
      token: "SAMPLE_TOKEN",
    });
    mock.onGet("user").reply(200, {
      status: "success",
      user: require("./generateUser"),
    });
  }

  // Forward unmatched APIs through the network
  mock.onAny().passThrough();
}
